import * as types from './actionTypes';

const initialState = {
  per_policy_list: null,
  loading: false,
  error: null,
  success: false,
};

const permissionPolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PERMISSION_POLICY_REQUEST:
    case types.SAVE_PERMISSION_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_PERMISSION_POLICY_SUCCESS:
      return {
        ...state,
        per_policy_list: action.payload?.data,
        loading: false,
        success: false,
      };

    case types.SAVE_PERMISSION_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.FETCH_PERMISSION_POLICY_FAILURE:
    case types.SAVE_PERMISSION_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default permissionPolicyReducer;
